import React from 'react';
import {ReactComponent as ReactLogo} from "../assets/Icons/expand.svg";

const Expand = ({color , width, height}) => {
  return (
      <div  className="toggleLogo" >
          <ReactLogo color={color} width={width} height={height} />

      </div>
  );
}
export default Expand;